import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { AmlResult } from './aml-result.enum';

export const AmlHitSummarySchema = z
    .object({
        adverseMedia: z.number().optional(),
        fitnessProbitity: z.number().optional(),
        pep: z.number().optional(),
        sanction: z.number().optional(),
        warning: z.number().optional(),
    })
    .strict();

export const AmlInfoSchema = z
    .object({
        amlHitSummary: AmlHitSummarySchema.optional(),
        result: EnumSchema(AmlResult).optional(),
    })
    .strict();

export class AmlHitSummary extends FromSchema(AmlHitSummarySchema) {
    adverseMedia?: number;
    fitnessProbitity?: number;
    pep?: number;
    sanction?: number;
    warning?: number;
}

export class AmlInfo extends FromSchema(AmlInfoSchema) {
    amlHitSummary?: AmlHitSummary;
    result?: AmlResult;
}
